import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgImprovedTeaAndCoffee = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 22,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 17v1H0v-1h22ZM13.586 0a1 1 0 0 1 .79 1.613l-.083.094L13 3v12H3l-.001-2H1v-1h1.999v-1H1a1 1 0 0 1-.993-.883L0 10V3a1 1 0 0 1 .883-.993L1 2h1.999L3 0h10.586Zm0 1H4v13h8V2.586L13.586 1ZM19 5v3h3v1h-3v3h-1V8.999L15 9V8l3-.001V5h1ZM2.999 3H1v7h1.999V3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgImprovedTeaAndCoffee;